// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

// Internal Dependencies:
import PageEvents from './PageEvents'
import PageHeader from './PageHeader'
import Content from './Content'
import ProgramTrack from 'components/ProgramTrack/ProgramTrack'
import { getUtcTimestampSeconds } from 'utilities/time'

// Redux:
import { setSidebarVisibility, getAccountLikesData, likeProgram } from 'actions/site'
import { getPageData } from 'actions/page'

class Program extends React.Component {
	constructor( props ) {
		super( props )

		let state = {
			tracksPageNumber: 1
		}

		this.state = state
	}

	componentDidMount() {
		window.scrollTo( 0, siteData.page_top_pos )
		document.querySelector( '.main' ).scrollTop = 0

		if ( ! this.props.match ) {
			return
		}

		const { params, path } = this.props.match

		if ( params.program ) {
			this.props.getPost( params.program, 'program' )
		}

		this.props.getAccountLikesData()
	}

	componentWillUnmount() {

	}

	componentDidUpdate( prevProps, prevState ) {
		if ( ! this.props.match ) {
			return
		}

		const { params, path } = this.props.match
		const prevParams = prevProps.match.params
		const prevPath = prevProps.match.path

		if ( params.program && prevParams.program !== params.program ) {
			window.scrollTo( 0, siteData.page_top_pos )
			document.querySelector( '.main' ).scrollTop = 0

			this.props.getPost( params.program, 'program' )
		}
	}

	handleLoadMore = () => {
		const { getPost, match } = this.props
		const { tracksPageNumber } = this.state
		const nextPage = tracksPageNumber + 1

		getPost( match.params.program, 'program', nextPage, false, true )

		this.setState( {
			tracksPageNumber: nextPage
		} )
	}

	renderLoading() {
		return (
			<div className="primary-content-inner primary-content-is-loading">

			</div>
		)
	}

	getPlaylist = ( items ) => {
		let returnValue = []
		const { page, rewindMaxHours } = this.props
		const utcTimestampSeconds = getUtcTimestampSeconds()

		Object.keys( items ).forEach( ( key, i ) => {
			let item = items[ key ]
			let lastPlayedSecondsAgo = utcTimestampSeconds - parseInt( item.last_played_timestamp_gmt, 10 )
			let lastPlayedHoursAgo = lastPlayedSecondsAgo / 60 / 60
			let canPlay = ( page.podcasts_enabled || lastPlayedHoursAgo <= rewindMaxHours )

			if ( canPlay ) {
				returnValue.push( {
					is_playlist: true,
					audio_file_url: item.audio_file_url,
					seconds: parseInt( item.seconds ),
					title: item.title,
					series: page.title.raw,
					series_slug: page.slug,
					guests: item.guests,
					number: item.number,
					most_recent_date: item.most_recent_date
				} )
			}
		} )

		return returnValue
	}

	renderPodcasts = ( podcastsItems, podcastsType, playlist, isSeriesLiked ) => {
		const { page } = this.props
		let markup = null
		const count = Object.keys( podcastsItems ).length

		markup = Object.keys( podcastsItems ).map( ( key, i ) => {
			let item = podcastsItems[ key ]
			item.url = item.audio_file_url

			if ( ! item.series_slug ) {
				item.series = page.title.raw
				item.series_slug = page.slug
			}

			let isLast = i == count - 1
			let playlistCurrentIndex = playlist.findIndex( o => o.audio_file_url === item.audio_file_url )

			return <ProgramTrack
				key={ item.url }
				data={ item }
				programData={ page }
				isLast={ isLast }
				playlist={ {
					playlist: playlist,
					currentIndex: playlistCurrentIndex
				} }
				isRecent={ 'recent' == podcastsType }
				isPodcast={ 'podcast' == podcastsType }
				isSeriesLiked={ isSeriesLiked }
			/>
		} )

		return markup
	}

	renderContent() {
		const { page, accountData, isBackgroundLoading, shareLinkData } = this.props

		if ( ! page ) {
			return null
		}

		const { params } = this.props.match
		document.title = page.title.raw

		// Image:
		let image

		if ( page.featured_image.url ) {
			image = (
				<div className="-image">
					<img className="-img" src={ page.featured_image.url } alt= { page.featured_image.alt } />
				</div>
			)
		}

		// Like:
		let isLiked = false

		if ( accountData && accountData.likes_series && accountData.likes_series[ params.program ] ) {
			isLiked = true
		}

		// Podcasts:
		let podcastsMarkup,
			podcastsItems = {},
			podcastsType = 'podcast',
			playlist = []

		if ( page.recently_played && Object.keys( page.recently_played ).length ) {
			podcastsType = 'recent'
			podcastsItems = page.recently_played
			playlist = this.getPlaylist( podcastsItems )

			podcastsMarkup = this.renderPodcasts( podcastsItems, podcastsType, playlist, isLiked )
		} else if ( page.podcasts && Object.keys( page.podcasts ).length ) {
			podcastsItems = page.podcasts
			playlist = this.getPlaylist( podcastsItems )

			podcastsMarkup = this.renderPodcasts( podcastsItems, podcastsType, playlist, isLiked )
		}

		let showShare = false
		let shareLinkPlaylistCurrentIndex = false

		if ( shareLinkData ) {
			showShare = true
			shareLinkPlaylistCurrentIndex = playlist.findIndex( o => o.audio_file_url === shareLinkData.audio_file_url )
		}

		if ( 'program-default' != page.slug && ! shareLinkData.series_slug ) {
			showShare = false
			shareLinkPlaylistCurrentIndex = false
		}

		return (
			<div className="primary-content-inner primary-content-is-ready">
				<PageEvents />

				<PageHeader isLiked={ isLiked } />

				<div className="content-body">
					<div className="program">
						<Content />

						{ showShare &&
							<section className="shared-track">
								<main className="program-podcasts">
									<div className="schedule-programs-wrap">
										<p className="-shared-text">Shared with you:</p>

										<div className="-programs">
											<ProgramTrack
												data={ shareLinkData }
												programData={ shareLinkData.program }
												isShare={ true }
												playlist={ {
													playlist: playlist,
													currentIndex: shareLinkPlaylistCurrentIndex
												} }
											/>
										</div>
									</div>
								</main>
							</section>
						}

						{ podcastsMarkup &&
							<section>
								<header>
									{ page.podcasts_enabled &&
										<h2>Podcasts</h2>
									||
										<h2>Recently Played</h2>
									}

									{ page.podcasts_enabled &&
										<div className="-podcast-links">
											{ page.podcast_url_itunes &&
												<a className="-podcast-link" href={ page.podcast_url_itunes } target="_blank" rel="noopener">
													<img className="-full" src={ `${siteData.images_url}programs/apple-podcasts-listen-badge.svg` } alt="Listen on Apple Podcasts" />
													<img className="-icon" src={ `${siteData.images_url}programs/apple-podcasts-listen-badge-icon.svg` } alt="Listen on Apple Podcasts" />
												</a>
											}

											{ page.podcast_url_google &&
												<a className="-podcast-link" href={ page.podcast_url_google } target="_blank" rel="noopener">
													<img className="-full" src={ `${siteData.images_url}programs/google-podcasts-listen-badge.svg` } alt="Listen on Google Podcasts" />
													<img className="-icon" src={ `${siteData.images_url}programs/google-podcasts-listen-badge-icon.svg` } alt="Listen on Google Podcasts" />
												</a>
											}

											{ page.podcast_url_spotify &&
												<a className="-podcast-link" href={ page.podcast_url_spotify } target="_blank" rel="noopener">
													<img className="-full" src={ `${siteData.images_url}programs/spotify-podcasts-listen-badge.svg` } alt="Listen on Spotify" />
													<img className="-icon" src={ `${siteData.images_url}programs/spotify-podcasts-listen-badge-icon.svg` } alt="Listen on Spotify" />
												</a>
											}

											<a className="-podcast-link" href={ `${siteData.podcast_rss_base_url}${params.program}` }>
												<img className="-full" src={ `${siteData.images_url}programs/rss-listen-badge.svg` } alt="Subscribe via RSS" />
												<img className="-icon" src={ `${siteData.images_url}programs/rss-listen-badge-icon.svg` } alt="Subscribe via RSS" />
											</a>
										</div>
									}
								</header>

								<main className="program-podcasts">
									<div className="schedule-programs-wrap">
										<div className="-programs">
											{ podcastsMarkup }
										</div>
									</div>

									{ ( page.has_more_pages && isBackgroundLoading ) &&
										<div className="button -load-more" onClick={ this.handleLoadMore } disabled="disabled">Loading...</div>
									|| ( page.has_more_pages ) &&
										<div className="button -load-more" onClick={ this.handleLoadMore }>Show More</div>
									}
								</main>
							</section>
						||
							<section>
								<header>
									<h3>No recent episodes</h3>
								</header>
							</section>
						}
					</div>
				</div>
			</div>
		)
	}

	render() {
		const { isLoading } = this.props

		return (
			<div>
				{ isLoading ? this.renderLoading() : this.renderContent() }
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		isLoading: state.page.isLoading,
		isBackgroundLoading: state.page.isBackgroundLoading,
		page: state.page.selected,
		loggedIn: state.site.loggedIn,
		accountData: state.site.accountData,
		shareLinkData: state.site.shareLinkData,
		rewindMaxHours: state.schedule.rewindMaxHours
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {
		getPost: ( slug, type, archivePageNumber, requestOnly = false, backgroundLoading = false ) => {
			dispatch( getPageData( slug, type, archivePageNumber, requestOnly, backgroundLoading ) )
		},

		setSidebarVisibility: ( val ) => {
			dispatch( setSidebarVisibility( val ) )
		},

		getAccountLikesData: () => {
			dispatch( getAccountLikesData() )
		},

		likeProgram( program ) {
			dispatch( likeProgram( program ) )
		}
	}
}

export default connect( mapStateToProps, mapDispatchToProps )( Program )
